export function isImage(url) {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg|jfif)$/.test(url);
}

export const isImageUpload = (textArr) => {
    if (textArr[0] === "image") return true;
    else return false;
};